export default class Loader {
  constructor() {
    this.loader = document.querySelector('[data-loader="loader"]');

    this.init();
  }

  init() {
    if (!this.loader) return;
    this.resolveLoad();
  }

  resolveLoad() {
    this.loader.classList.add('is-loaded')
    setTimeout(() => {
      this.loader.style.display = 'none';
      this.loader.classList.add('is-initial');
    }, 3000);
  }
}